import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function Close(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("div", {
    className: styles['close-btn'],
    onClick: onClick,
    "data-testid": "WebimChatClose"
  });
}